import { useBoot } from "./Layout";
import { mediaUrl } from "../content/images";

// Uses the CMS-uploaded logo (Settings > Médias du site > logo) when present,
// otherwise falls back to the labelled placeholder mark.
export const Logo = ({ dark = true, compact = false }) => {
  const boot = useBoot();
  const logo = boot?.settings?.media?.logo;
  if (logo) {
    return (
      <span className="inline-flex items-center" data-testid="brand-logo">
        <span className="inline-flex items-center rounded-lg bg-white px-2.5 py-1.5 shadow-sm">
          <img src={mediaUrl(logo)} alt="Bula Telecoms" className={compact ? "h-7 w-auto" : "h-9 w-auto"} />
        </span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <svg width={compact ? 30 : 36} height={compact ? 30 : 36} viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <circle cx="24" cy="24" r="21" stroke="#FF6600" strokeWidth="2.5" strokeDasharray="4 5" className="origin-center animate-[spin_24s_linear_infinite]" />
        <circle cx="24" cy="24" r="14" stroke={dark ? "#FFFFFF" : "#101214"} strokeWidth="2" opacity="0.85" />
        <circle cx="24" cy="24" r="6.5" fill="#FF6600" />
        <circle cx="24" cy="3" r="3" fill="#FF9900" />
        <circle cx="45" cy="24" r="3" fill="#FFC000" />
      </svg>
      <span className={`leading-none ${dark ? "text-white" : "text-[#101214]"}`}>
        <span className="block font-black text-lg tracking-tight">BULA</span>
        <span className="block font-bold text-[10px] tracking-[0.28em] text-[#FF6600]">TELECOMS</span>
      </span>
    </span>
  );
};
